module.exports = __webpack_public_path__ + "img/pdf-icon.32d7dca2.svg";